import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router"
import VueApollo from "vue-apollo";
import apolloClient from "./vue-apollo";
import x5GMaps from 'x5-gmaps'
import Vuelidate from 'vuelidate'
import titleMixin from './mixins/titleMixin'


Vue.config.productionTip = false;

Vue.use(x5GMaps, 'AIzaSyAavmwYsP_Rt6I6l7_IJAP4Q1AwBCUpE4U')
Vue.mixin(titleMixin)
Vue.use(Vuelidate)
Vue.use(VueApollo);
Vue.use(VueRouter);

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/",
      components: require("./containers/Articles.vue")
    },
    {
      path: "/contact",
      components: require("./containers/Contact.vue")
    },
    {
      path: "/:id",
      components: require("./containers/Article.vue")
    },
    // {
    //   path: "/category/:id",
    //   components: require("./containers/Category.vue")
    // },
  ]
});

new Vue({
  apolloProvider,
  router,
  render: h => h(App)
}).$mount("#app");